/**
 * Format: Option
 * -----------------------------------------------------------------------------
 * Formats Shopify storefront API options response.
 *
 */
import { formatMoney } from '@we-make-websites/theme-currency'

/**
 * Format product options array.
 * @param {Object} product - Product response.
 * @param {Array} variants - Formatted variants response.
 * @returns {Array}
 */
export function formatOptions(product, variants) {
  if (!product.options?.length) {
    return []
  }

  return product.options.map((option, index) => {
    return formatOption(option, { index, product, variants })
  })
}

/**
 * Format product option.
 * - https://shopify.dev/docs/api/storefront/2024-01/objects/ProductOption
 * @param {Object} option - Option response.
 * @param {Object} [data] - Additional data.
 * @param {Number} [data.index] - Forloop index.
 * @param {Object} [data.product] - Product response.
 * @param {Array} [data.variants] - Formatted variants response.
 * @returns {Object}
 */
function formatOption(option, { index, product, variants } = {}) {
  const formattedOption = {
    index,
    labels: option.values,
    name: option.name,
    values: option.values,
    isOnSale: variants.map((variant) => variant.isOnSale),
  }

  /**
   * If gift card then show price as label to support multi-currency.
   */
  if (product.giftCard && variants.length) {
    formattedOption.labels = option.values.map((_, valueIndex) => {
      return formatMoney(variants[valueIndex].price.amount, cnvs.store.moneyFormat)
    })
  }

  return formattedOption
}
